import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  bearbeitungen: [],
  loading: false,
  error: null
}

// getters
const getters = {
  bearbeitung: (state) => (id) => {
    return state.bearbeitungen.find(bearbeitung => bearbeitung.id === id)
  },
  bearbeitungVonBbr: (state) => (elementId) => {
    let items = []
    state.bearbeitungen.forEach(bearbeitung => {
      if (bearbeitung.elementId === elementId) {
        items.push(bearbeitung)
      }
    })
    return items
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadBearbeitungen ({commit}) {
    commit('setLoading', true)
    console.log('Bearbeitungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bearbeitungen').orderBy('datum', 'desc')
    .onSnapshot(snapshot => {
      const bearbeitungen = []
      snapshot.forEach(doc => {
        if (!doc.data().delete) {
          bearbeitungen.push({
            ...doc.data(),
            id: doc.id
          })
        }
        commit('setLoadedBearbeitungen', bearbeitungen)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createBearbeitung ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bearbeitungen').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteBearbeitungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bearbeitungen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteBearbeitung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateBearbeitungData ({commit, state}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bearbeitungen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      // commit('updateBearbeitung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedBearbeitungen (state, payload) {
    state.bearbeitungen = payload
  },
  createBearbeitung (state, payload) {
    state.bearbeitungen.push(payload)
  },
  updateBearbeitung (state, payload) {
    const bearbeitung = state.bearbeitungen.find(bearbeitung => {
      return bearbeitung.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        bearbeitung[key] = payload[key]
      }
    })
  },
  deleteBearbeitung (state, payload) {
    let array = state.bearbeitungen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.bearbeitungen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bearbeitungen_alt.js